webpackJsonp([35783957827783],{

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trucks.5c92f39e.jpg";

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _trucks = __webpack_require__(439);
	
	var _trucks2 = _interopRequireDefault(_trucks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "text-center" },
	    _react2.default.createElement("img", { src: _trucks2.default, className: "block mx-auto" }),
	    _react2.default.createElement(
	      "h2",
	      { className: "bg-yellow inline-block my-8 p-3" },
	      "Gather Metrics. Report. Analyze."
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "leading-loose" },
	      "Simplify your fleet reporting!"
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ae15dc09d94a5f6cd767.js